import { ActionName } from '../enums';
import BaseOpenModalAction from './base-open-modal.action';
import { IconType } from '@/ui-kit/components/icon/enums';
import ModalService from '@/ui-kit/components/modal/ModalService';
import ShareListingModal from '@/components/share-listing-modal';

export default class ShareAction extends BaseOpenModalAction {
  name = ActionName.ShareListing;
  icon = IconType.Share;

  // eslint-disable-next-line class-methods-use-this
  openModal(listing) {
    return ModalService.open({
      component: ShareListingModal,
      data: { listing },
    });
  }
}
